import React, { CSSProperties } from 'react';
import { CustomFieldType, CustomField, ExtendedFields } from '@wix/bex-core';
import { Column } from '../model';
import { ExtendedColumn } from '../components/ExtendedColumn/ExtendedColumn';
import { DataTableColumnAlign } from '@wix/design-system/dist/types/Table/DataTable';

const ExtendedColumnsConfig: Record<
  CustomFieldType,
  { style?: CSSProperties; width?: string; align?: DataTableColumnAlign }
> = {
  shortText: {
    width: '150px',
    align: 'start',
  },
  dateTime: {
    width: '200px',
    align: 'center',
  },
  date: {
    width: '150px',
    align: 'center',
  },
  decimal: {
    width: '100px',
    align: 'center',
  },
  integer: {
    width: '100px',
    align: 'center',
  },
  checkbox: {
    width: '100px',
    align: 'center',
  },
  longText: {
    width: '250px',
    align: 'start',
  },
  dropdown: {
    width: '150px',
    align: 'start',
  },
};

export const customFieldColumnIdPrefix =
  'extendedFields.namespaces._user_fields.';

export function simplifyExtendedColumns<T>({
  fields,
  toExtendedFields,
}: {
  fields: CustomField[];
  toExtendedFields?: (item: T) => ExtendedFields | undefined;
}): Column[] {
  return fields.map((field) => {
    const type = field.type;
    return {
      dataExtension: field,
      id: `${customFieldColumnIdPrefix}${field.id}`,
      name: field.label || field.id,
      title: field.label || field.id,
      hideable: true,
      align: type ? ExtendedColumnsConfig[type].align : undefined,
      width: type ? ExtendedColumnsConfig[type].width : undefined,
      style: type ? ExtendedColumnsConfig[type].style : undefined,
      render: (row) => {
        const value =
          toExtendedFields?.(row)?.namespaces?._user_fields?.[field.id];
        return <ExtendedColumn type={type} value={value} />;
      },
    };
  });
}
